export default {
  we_unite_the__:
    "We unite the entire network into one thriving community, guiding you toward the path that best aligns with your goals. ".toUpperCase(),
  learn_more__: "Learn More about Vision".toUpperCase(),
  we_are_putting__:
    "We are putting our community in a way, which will make it impossible to wipe or delete by anyone.".toUpperCase(),
  this_is_the__: "This is the next-generation catalog you’ve never seen before.".toUpperCase(),
  featured_vlogs: "Featured Vlogs".toUpperCase(),
  featuring_real__:
    "Featuring real-time ratings, deep insights, exclusive announcements, daily support, and constant updates. ".toUpperCase(),
};
